import React, { Fragment, type FC } from "react";

export type NutritionMealTableMacroIndicatorProps = {
  main: boolean;
  label: string;
  unit: string;
  indicator: string;
  value: string;
  empty: boolean ;
};

export const NutritionMealTableMacroIndicator: FC<
  NutritionMealTableMacroIndicatorProps
> = ({ main, label, unit, indicator, value, empty }) => {
  return (
    <dd className="flex items-center justify-start flex-wrap">
      <div className="mr-2">{label}</div>
      {main ? (
        <div className="flex flex-row gap-1">
          <div className="flex items-baseline text-base font-semibold text-primary-600">
            {value}
          </div>
          <div className="text-gray-500 text-base">{unit}</div>
        </div>
      ) : (
        <Fragment>
          {empty ? (
            <span className="text-gray-500">-</span>
          ) : (
            <span className="text-red-500">{indicator}</span>
          )}
        </Fragment>
      )}
    </dd>
  );
};
